/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable class-methods-use-this */
import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { LoginButton, SignupButton, SignOutButton } from "../../ui/buttons";
import { downloadFile, getRegions } from "./actions";
import Archive, { IArchive } from "./Archive";
import ArchiveSimple from "./ArchiveSimple";
import styles from "./download.module.scss";
import ARCHIVES from "../../constants/archives.json";

interface IProps {
  auth: any;
  filesDownloading: any;
  downloadingRegion: any;
  regions: any;
  getRegions: () => Promise<void>;
  downloadFile: (
    file: string,
    region: string,
    project: "nuScenes" | "nuPlan"
  ) => Promise<void>;
}

interface IState {
  archives: IArchive[];
}

/**
 * Individual page for nuScenes downloads. Should really be a
 * React functional component, but using the latest react-redux with types
 * breaks everything in this project.... sad.
 */
class NuScenesDownload extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);

    // Doesn't actually need to be state. Keeping it to mimic ./Downloads.tsx. Also when importing
    // ARCHIVES, it doesn't have a type, so we need to cast it to its proper type.
    this.state = {
      archives: (ARCHIVES as IArchive[]).filter((a) => a.type === "nuScenes"),
    };
  }

  public componentDidMount(): void {
    const { auth, getRegions } = this.props;
    if (auth) {
      getRegions();
    }
  }

  public render(): JSX.Element {
    const { auth, filesDownloading, regions, downloadingRegion, downloadFile } =
      this.props;
    const { archives } = this.state;

    return (
      <div className={styles.wrapper}>
        <div className={`content pb-2em text-justify ${styles.mobileContent}`}>
          <div className={`flex vertical-center ${styles.titleWrapper}`}>
            {auth && <SignOutButton />}
          </div>

          <div className={styles.block + " " + (auth ? "" : styles.flex)}>
            <div className={styles.left}>
              <p className={styles.text}>
                Here we list the different releases of the nuScenes
                datasets.&nbsp;You can be a registered user to view and download
                them.&nbsp;
                {auth && (
                  <span>
                    For instructions on how to setup and use this data, please
                    see the{" "}
                    <a
                      href="https://github.com/nutonomy/nuscenes-devkit"
                      target="_blank"
                      className={styles.green}
                      rel="noreferrer"
                    >
                      nuScenes devkit
                    </a>
                    . The following files are available for download:
                  </span>
                )}
              </p>
              {!auth && (
                <p className={styles.pleaseLogin}>
                  Please register and login to download the nuScenes dataset
                  free of charge for{" "}
                  <Link to="/terms-of-use">non-commercial use</Link>, so that we
                  can better track its usage.
                  <br />
                  <br />
                  This dataset is also available at{" "}
                  <a href="https://registry.opendata.aws/">
                    Registry of Open Data on AWS
                  </a>
                  .
                </p>
              )}
            </div>
            {auth ? (
              <div>
                {archives.map((archive, i) => {
                  if (_.isArray(_.get(archive, "subsets.0.archives", null))) {
                    return (
                      <Archive
                        key={`${archive.name}-${i}`}
                        archives={archives}
                        archive={archive}
                        archiveIndex={i}
                        filesDownloading={filesDownloading}
                        regions={regions}
                        downloadingRegion={downloadingRegion}
                        project="nuScenes"
                        downloadFile={downloadFile}
                      />
                    );
                  }
                  return (
                    <ArchiveSimple
                      key={`${archive.name}-${i}`}
                      archives={archives}
                      archive={archive}
                      archiveIndex={i}
                      filesDownloading={filesDownloading}
                      regions={regions}
                      downloadingRegion={downloadingRegion}
                      downloadFile={downloadFile}
                      project="nuScenes"
                    />
                  );
                })}
              </div>
            ) : (
              <div className={styles.right}>
                <SignupButton />
                <LoginButton />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.login.auth,
  filesDownloading: state.download.filesDownloading,
  downloadingRegion: state.download.downloadingRegion,
  regions: state.download.regions,
});

const mapDispatchToProps = {
  getRegions,
  downloadFile,
};

export default connect(mapStateToProps, mapDispatchToProps)(NuScenesDownload);
